import React from 'react';

import {Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

const NotAvailable = () => {
    const { t } = useTranslation();

            return (
                <Box flexGrow={1} >
                    {t(`notavailable`)}
                </Box>
            );
        }

export default NotAvailable;